
_ = require 'lodash'

exports.OOSHIRTS_USER_ID = OOSHIRTS_USER_ID = '57a26d2a7470cb473a565dae'
exports.TEECHIP_USER_ID = TEECHIP_USER_ID = '57746a4644a695ad11537433'
exports.ALPHA_TEST_USER_ID = ALPHA_TEST_USER_ID = '59a72815b7db791512451646'
exports.ALPHA_USER_ID = ALPHA_TEST_USER_ID = '589e2be57a1a4fe7022458b5'

exports.PERSONAS = {
  PROMOTIONAL: 'promotional'
  ECOMMERCE: 'e-commerce'
  OTHER: 'other'
}

exports.BLOCK_REASONS = BLOCK_REASONS = {
  OVERDUE_INVOICES: 'overdue-invoices'
}
exports.BLOCK_REASONS_LIST = _.values(BLOCK_REASONS)
exports.BLOCK_READABLE = BLOCK_READABLE = {
  "#{BLOCK_REASONS.OVERDUE_INVOICES}": "overdue invoices"
}
exports.BLOCK_MESSAGE = BLOCK_MESSAGE = {
  "#{BLOCK_REASONS.OVERDUE_INVOICES}": "please pay overdue invoices to resume account activity."
}

exports.EMAIL_REGEX = EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
exports.validEmail = validEmail = (email) -> return EMAIL_REGEX.test(email)
exports.normalizeEmail = normalizeEmail = (email) -> return email.toLowerCase().trim()



// WEBPACK FOOTER //
// ./~/oo-components/utils/user.coffee